import React from 'react';
import { Wrench, Hammer, Home, Monitor, Leaf } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const services = [
  {
    icon: Hammer,
    title: 'Bricolage à Elven',
    description: 'Petits travaux de bricolage : montage de meubles, réparations, pose de luminaires. Artisan multiservices à Elven, Saint-Nolff, Trédion et Morbihan.',
    image: 'https://images.unsplash.com/photo-1505798577917-a65157d3320a',
  },
  {
    icon: Wrench,
    title: 'Installation & Aménagement',
    description: 'Travaux d\'installation : cuisines en kit, armoires, étagères, bibliothèques. Fixation d\'éléments muraux à Elven et alentours.',
    image: 'https://images.unsplash.com/photo-1676311396794-f14881e9daaa',
  },
  {
    icon: Leaf,
    title: 'Jardinage à Elven',
    description: 'Travaux de jardinage : tonte, taille de haies, désherbage, entretien d\'espaces verts. Jardinier multiservices à Elven et communes du Morbihan.',
    image: 'https://images.unsplash.com/photo-1724556295135-ff92b9aa0a55',
  },
  {
    icon: Monitor,
    title: 'Informatique à Elven',
    description: 'Travaux informatiques : dépannage, installation PC/Mac, box internet. Assistance multiservices à domicile à Elven et communes du Morbihan.',
    image: 'https://images.unsplash.com/photo-1604754742629-3e5728249d73',
  },
  {
    icon: Home,
    title: 'Réparations & Entretien',
    description: 'Petits travaux de réparation : poignées, joints, entretien courant à Elven et environs. Travail soigné et minutieux.',
    image: 'https://images.pexels.com/photos/7484798/pexels-photo-7484798.jpeg',
  },
];

export const Services = () => {
  return (
    <section id="services" className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            Mes <span className="text-green-600">Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Travaux de bricolage, jardinage et informatique à Elven et dans 15 communes du Morbihan. Artisan multiservices à domicile.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="service-card border-none shadow-lg hover:shadow-2xl overflow-hidden group"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={`${service.title} - DMS David Multi Service Elven`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                  </div>
                </div>
                <CardContent className="p-6 space-y-3">
                  <h3 className="text-xl font-bold text-gray-900">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-green-50 rounded-2xl p-8 border-2 border-green-100">
            <p className="text-lg text-gray-700 mb-4">
              Besoin d'un service particulier ? N'hésitez pas à me contacter !
            </p>
            <a href="tel:0744921208" className="text-green-600 font-semibold text-xl hover:text-green-700">
              07 44 92 12 08
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};